import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryArrowIcon]" })
export class QueryArrowIconDirective {
  constructor(public template: TemplateRef<any>) {}
}
